import styled, { css } from 'styled-components';
import { NewTabLink, StyledLink } from 'ui/links';
import { link2, overline, spacing, textColors } from 'ui/theme';
import { BasicSelectField, MultiFilterSelectField } from 'lib/iterable-hook-form/FormField';

export const SectionWrapper = styled.section``;

export const SectionHeader = styled.div`
  ${overline};
  color: ${textColors.textSecondary};
  margin: ${spacing.double} 0 ${spacing.plusHalf};
  &:not(:first-child) {
    margin-top: ${spacing.plusHalf};
  }
`;

export const CommaSeparatedList = styled.ul`
  list-style: none;
  padding: 0px;
`;

export const CommaSeparatedListItem = styled.li`
  display: inline;
  &::after {
    content: ', ';
  }
  &:last-child::after {
    content: '';
  }
`;

export const SpaceSeparatedList = styled.div`
  display: inline-block;
  padding: 0px;
`;

export const SpaceSeparatedListItem = styled.div`
  display: inline-block;
  margin: 0 ${spacing.base} ${spacing.half} 0;
  white-space: nowrap;
`;

export const NewLineSeparatedListItem = styled.div`
  display: flex;
  align-items: center;
  margin: 0 ${spacing.base} ${spacing.half} 0;
`;

export const LightText = styled.span`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

export const FullWidthSelectField = styled(BasicSelectField)`
  width: 100%;
`;

export const FullWidthMultiFilterSelectField = styled(MultiFilterSelectField)`
  width: 100%;
`;

const baseLinkStyles = css`
  span {
    max-width: ${spacing.x16};
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:focus {
    margin-left: ${spacing.eighth};
    margin-top: ${spacing.single};
  }
  &:hover {
    text-decoration: none !important;
  }
`;

export const StyledNewTabLink = styled(NewTabLink)`
  ${baseLinkStyles}
`;

export const StyledButtonLink = styled(StyledLink)`
  ${baseLinkStyles}
`;

export const StyledNewTabEventLink = styled(NewTabLink)`
  ${link2}
  svg {
    margin-bottom: 0;
  }
  text-decoration: none;
`;

export const StyledNewTabListLink = styled(NewTabLink)`
  ${link2}
  svg {
    margin-bottom: 0;
  }
  text-decoration: none;
`;

export const FieldWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  & > div {
    width: unset;
  }
`;

export const CriteriaListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

export const WithBulletPoint = styled.div`
  &:before {
    content: '\u2022  ';
  }
`;
